import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { api } from '../lib/api'
import { toast } from '../lib/toast'
import Button from '../components/ui/Button'
import Input from '../components/ui/Input'

export default function ResetPassword() {
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const [pw, setPw] = useState('')
  const [pw2, setPw2] = useState('')
  const [busy, setBusy] = useState(false)
  const navigate = useNavigate()

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    if (pw.length < 8) {
      toast.error('Şifre en az 8 karakter olmalı')
      return
    }
    if (pw !== pw2) {
      toast.error('Şifreler eşleşmiyor')
      return
    }
    setBusy(true)
    try {
      await api('/api/auth/reset-password', {
        method: 'POST',
        body: JSON.stringify({ token, new_password: pw }),
      })
      toast.success('Şifre güncellendi. Şimdi giriş yapabilirsin.')
      navigate('/login')
    } catch (err) {
      toast.error((err as Error).message)
    } finally {
      setBusy(false)
    }
  }

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="text-center space-y-3">
          <p>Token eksik. Linkin geçerli olduğundan emin ol.</p>
          <Link to="/forgot-password" className="text-sm hover:underline">
            Yeni link iste
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm space-y-4">
        <h1 className="text-2xl font-semibold">Yeni şifre belirle</h1>
        <form onSubmit={submit} className="space-y-3">
          <Input
            type="password"
            placeholder="Yeni şifre (en az 8)"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            required
          />
          <Input
            type="password"
            placeholder="Yeni şifre (tekrar)"
            value={pw2}
            onChange={(e) => setPw2(e.target.value)}
            required
          />
          <Button type="submit" disabled={busy} variant="primary">
            {busy ? 'Güncelleniyor...' : 'Şifreyi güncelle'}
          </Button>
        </form>
      </div>
    </div>
  )
}
